import { Column, DateRangeInput, Row, Select } from "best-common-react";
import React from "react";
import { useAdminReporting } from "../../../contexts/ admin/AdminReportingContext";
import { useMetadata } from "../../../contexts/MetadataContext";

const AdminReportingForm = () => {
  const { filters, changeFilters, search } = useAdminReporting();
  const { orgOptions, getValueFromOptions } = useMetadata();

  return (
    <div className="bcr-mb-3">
      <form
        onSubmit={(event) => {
          event.preventDefault();
          void search();
        }}
      >
        <Row>
          <Column width={2}>
            <DateRangeInput
              id="dateRange"
              label="Date Range"
              value={filters.dateRange}
              onChange={(value) => changeFilters("dateRange", value)}
              withPortal
              maxRange={{
                months: 1,
              }}
            />
          </Column>
          <Column width={2}>
            <Select
              id="club"
              label="Club"
              options={orgOptions}
              value={getValueFromOptions(orgOptions, filters.org)}
              onChange={(event) => changeFilters("org", event.value)}
            />
          </Column>
        </Row>
      </form>
    </div>
  );
};

export default AdminReportingForm;
